import {
  WifiIcon,
  SwimmingPoolIcon,
  UtensilsIcon,
  WineGlassIcon,
  SquareParkingIcon,
  KitchenSetIcon,
  FenceIcon,
  BathIcon,
  ClimateIcon,
  MountainIcon,
  GroupsIcon,
  LanguageIcon,
  DollarIcon,
  ShieldIcon,
  TemperatureHalfIcon,
  PlaneIcon,
  HotelIcon,
  CarIcon,
  StarIcon,
  ClockIcon,
  CircleCheckIcon,
  LocationDotIcon,
  CalendarIcon,
} from '@/components/Icons';

import type { IconSize } from '@/components/Icons';

export function getIcon(iconName: string, size?: IconSize) {
  const icon = iconName.toLowerCase();
  switch (icon) {
    case 'wifi':
      return <WifiIcon size={size} />;
    case 'pool':
      return <SwimmingPoolIcon size={size} />;
    case 'restaurant':
      return <UtensilsIcon size={size} />;
    case 'bar':
      return <WineGlassIcon size={size} />;
    case 'parking':
      return <SquareParkingIcon size={size} />;
    case 'kitchen':
      return <KitchenSetIcon size={size} />;
    case 'balcony':
      return <FenceIcon size={size} />;
    case 'jacuzzi':
      return <BathIcon size={size} />;
    case 'klimaat':
      return <ClimateIcon size={size} />;
    case 'activiteiten':
      return <GroupsIcon size={size} />;
    case 'natuur':
      return <MountainIcon size={size} />;
    case 'prijsniveau':
      return <DollarIcon size={size} />;
    case 'taal':
      return <LanguageIcon size={size} />;
    case 'temperatuur':
      return <TemperatureHalfIcon size={size} />;
    case 'eten':
      return <UtensilsIcon size={size} />;
    case 'veiligheid':
      return <ShieldIcon size={size} />;
    case 'flight':
      return <PlaneIcon size={size} />;
    case 'accommodation':
      return <HotelIcon size={size} />;
    case 'carrental':
    case 'car':
      return <CarIcon size={size} />;
    case 'excursion':
      return <MountainIcon size={size} />;
    case 'star':
      return <StarIcon size={size} />;
    case 'clock':
      return <ClockIcon size={size} />;
    case 'check':
      return <CircleCheckIcon size={size} />;
    case 'location':
      return <LocationDotIcon size={size} />;
    case 'date':
      return <CalendarIcon size={size} />;
    default:
      return '';
  }
}
